import { P2GButton, P2GGrid, P2GTextBox } from '@parcel2go/core-ui';
import { useTenant } from '@parcel2go/npm-p2g-app';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { PublicSettings } from '~/lib/ui-serverless-settings';

interface ITrackingSearchBoxProps {
  onClick: (value: string) => void;
}

const TrackingSearchBox: React.FC<ITrackingSearchBoxProps> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  const [value, setValue] = React.useState<string>('');
  const label = t('SEARCH_TEXTBOX', { defaultValue: 'Enter Your Tracking Reference' });
  const { settings } = useTenant();
  const helperText = t('SEARCH_TEXTBOX_HELPER', 'e.g. {{prefix}}12345678', {
    prefix: settings[PublicSettings.PREFIX]
  });

  return (
    <P2GGrid container spacing={2} direction="column">
      <P2GGrid item>
        <P2GTextBox id="txtTrackingNumber" onChange={setValue} value={value} label={label} helperText={helperText} />
      </P2GGrid>
      <P2GGrid item>
        <P2GButton variant="tertiary" onClick={() => props.onClick(value)}>
          <Trans t={t} i18nKey="SEARCH_BUTTON" defaults="Track" />
        </P2GButton>
      </P2GGrid>
    </P2GGrid>
  );
};

export default TrackingSearchBox;
